import { productlist, type ProductsType } from "../../../data/pages/ecommers/productdata";


const ActionTypes = {
    THEME_CHANGER: "ThemeChanger",
    SET_SELECTED_ITEM: "SET_SELECTED_ITEM",
    ADD_TO_WISHLIST: "ADD_TO_WISHLIST",
    REMOVE_FROM_WISHLIST: "REMOVE_FROM_WISHLIST",
    ADD_TO_CART: "ADD_TO_CART",
    REMOVE_FROM_CART: "REMOVE_FROM_CART",
    UPDATE_CART_QUANTITY: "UPDATE_CART_QUANTITY",
    ADD_TO_CHECKOUT: "ADD_TO_CHECKOUT",
    BUY_NOW_CHECKOUT: "Buynow_checkout",
} as const;

interface ThemeChangerPayload {
    lang?: string;
    dir?: string;
    dataThemeMode?: string;
    dataMenuStyles?: string;
    dataNavLayout?: string;
    dataHeaderStyles?: string;
    dataVerticalStyle?: string;
    toggled?: string;
    dataNavStyle?: string;
    dataPageStyle?: string;
    dataWidth?: string;
    dataMenuPosition?: string;
    dataHeaderPosition?: string;
    loader?: string;
    iconOverlay?: string;
    colorPrimaryRgb?: string;
    colorPrimary?: string;
    bodyBg1?: string;
    bodyBg2?: string;
    Light?: string;
    Formcontrol?: string;
    inputBorder?: string;
    Graycolor?: string;
    bgImg?: string;
    iconText?: string;
    body?: string;
}

type Action =
    | { type: typeof ActionTypes.THEME_CHANGER; payload: ThemeChangerPayload }
    | { type: typeof ActionTypes.SET_SELECTED_ITEM; payload: ProductsType | null }
    | { type: typeof ActionTypes.ADD_TO_WISHLIST; payload: ProductsType }
    | { type: typeof ActionTypes.REMOVE_FROM_WISHLIST; payload: { id: string | number } }
    | { type: typeof ActionTypes.ADD_TO_CART; payload: ProductsType }
    | { type: typeof ActionTypes.REMOVE_FROM_CART; payload: { id: string | number } }
    | { type: typeof ActionTypes.UPDATE_CART_QUANTITY; payload: { id: string | number; quantity: number } }
    | { type: typeof ActionTypes.ADD_TO_CHECKOUT; payload: ProductsType }
    | { type: typeof ActionTypes.BUY_NOW_CHECKOUT };

interface State {
    // ... your state properties here (same as before)
    lang: string;
    dir: string;
    dataThemeMode: string;
    dataMenuStyles: string;
    dataNavLayout: string;
    dataHeaderStyles: string;
    dataVerticalStyle: string;
    toggled: string;
    dataNavStyle: string;
    dataPageStyle: string;
    dataWidth: string;
    dataMenuPosition: string;
    dataHeaderPosition: string;
    loader: string;
    iconOverlay: string;
    colorPrimaryRgb: string;
    colorPrimary: string;
    bodyBg1: string;
    bodyBg2: string;
    Light: string;
    Formcontrol: string;
    inputBorder: string;
    Graycolor: string;
    bgImg: string;
    iconText: string;
    body: string;
    selectedItem: ProductsType | null;
    wishlist: ProductsType[];
    cart: ProductsType[];
    count: number;
    checkoutItems: ProductsType[];
    products: typeof productlist;
}

const initialState: State = {
    lang: "en",
    dir: "ltr",
    dataThemeMode: "light",
    dataMenuStyles: "light",
    dataNavLayout: "vertical",
    dataHeaderStyles: "light",
    dataVerticalStyle: "overlay",
    toggled: "",
    dataNavStyle: "",
    dataPageStyle: "regular",
    dataWidth: "default",
    dataMenuPosition: "fixed",
    dataHeaderPosition: "fixed",
    loader: "disable",
    iconOverlay: "",
    colorPrimaryRgb: "",
    colorPrimary: "",
    bodyBg1: "",
    bodyBg2: "",
    Light: "",
    Formcontrol: "",
    inputBorder: "",
    Graycolor: "",
    bgImg: "",
    iconText: "",
    body: "",
    selectedItem: null,
    wishlist: [],
    cart: [],
    count: 0,
    checkoutItems: [],
    products: productlist,
};

const addUniqueItem = (list: ProductsType[], item: ProductsType) => {
    if (list.find(i => i.id === item.id)) return list; // Avoid duplicates
    return [...list, item];
};

const removeItemById = (list: ProductsType[], id: string | number) =>
    list.filter(item => item.id !== id);

const updateItemQuantity = (list: ProductsType[], id: string | number, quantity: number) =>
    list.map(item => (item.id === id ? { ...item, quantity } : item));

const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case ActionTypes.THEME_CHANGER:
            return { ...state, ...action.payload };

        case ActionTypes.SET_SELECTED_ITEM:
            return { ...state, selectedItem: action.payload };

        case ActionTypes.ADD_TO_WISHLIST:
            return { ...state, wishlist: addUniqueItem(state.wishlist, action.payload) };

        case ActionTypes.REMOVE_FROM_WISHLIST:
            return { ...state, wishlist: removeItemById(state.wishlist, action.payload.id) };

        case ActionTypes.ADD_TO_CART:
            return { ...state, cart: addUniqueItem(state.cart, action.payload) };

        case ActionTypes.REMOVE_FROM_CART:
            return { ...state, cart: removeItemById(state.cart, action.payload.id) };

        case ActionTypes.UPDATE_CART_QUANTITY:
            return {
                ...state,
                cart: updateItemQuantity(state.cart, action.payload.id, action.payload.quantity),
            };

        case ActionTypes.ADD_TO_CHECKOUT:
            return { ...state, checkoutItems: addUniqueItem(state.checkoutItems, action.payload) };

        case ActionTypes.BUY_NOW_CHECKOUT:
            return { ...state, checkoutItems: [], cart: [] };

        default:
            return state;
    }
};

export default reducer;
